import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Timeline} from "primereact/timeline";
import {Button} from "primereact/button";
import axios from "axios";
import currencyFormatter from "currency-formatter";

const MilestoneListComponent = (props) => {

  const history = useHistory();
  const {entity, action, id} = useParams();
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(false);

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    if(id && entity === 'project') {
      setLoading(true);
      let _milestones = []
      apiCall('get', '/api/v2/milestone?search[project][operator]==&search[project][value]=' + id)
        .then(response => {
          if(response.data.data.items && response.data.data.items[0]) {
            response.data.data.items.map((item, index) => {
              _milestones.push({
                label: item.name,
                status: 'success',
                original: item,
              })
            })
          }
          _milestones.push({
            label: '',
            status: ''
          })
          setMilestones(_milestones)
        })
    }
    window.App.setState({rerenderProjectPage: Math.random()});
  }, [window.App.state.rerenderMilestoneList])

  return (
    <>
      <Timeline layout="horizontal" align="top"
                className={"project-milestones"}
                value={milestones}
                marker={(item, index) => {
                  if(item.status === 'success') {
                    return(
                      <>
                        <i className={"pi pi-circle-fill"}
                           style={{
                             color: "#883cae",
                             fontSize: '1.5rem',
                             position: 'relative',
                             zIndex: '9',
                             borderRadius: '100%'
                           }}></i>
                      </>
                    )
                  } else {
                    return (
                      <Button type="button" label={props.t('addMilestone')} icon="pi pi-plus"
                              className="p-button-success p-ml-2 p-text-nowrap"
                              style={{marginTop: '-7px'}
                              }
                              onClick={() => {
                                history.push('/project/' + entity + '/' + action + '/' + id + '?create=milestone')
                              }}
                      />
                    )
                  }

                }}
                content={(item, index) => {
                  console.log(item)
                  if(item.status === 'success') {
                    return (
                      <>
                        <h4 className={"p-mb-0"}>
                          {item.label}
                        </h4>
                        {window.App.formatDateValue(item?.original?.issue_date)}
                        <strong className={"p-d-block p-mt-3"}>Tervezett bevétel:</strong>
                        {currencyFormatter.format(
                          item?.original?.income_plan, {
                            precision: 0,
                            symbol: '',
                            decimal: ',',
                            thousand: ' ',
                          }
                        )}
                        <strong className={"p-d-block"}>Bérköltség:</strong>
                        {currencyFormatter.format(
                          item?.original?.cost_salary_plan, {
                            precision: 0,
                            symbol: '',
                            decimal: ',',
                            thousand: ' ',
                          }
                        )}
                        <strong className={"p-d-block"}>Anyag költség:</strong>
                        {currencyFormatter.format(
                          item?.original?.cost_material_plan, {
                            precision: 0,
                            symbol: '',
                            decimal: ',',
                            thousand: ' ',
                          }
                        )}
                        <strong className={"p-d-block"}>Egyéb költség:</strong>
                        {currencyFormatter.format(
                          item?.original?.cost_other_plan, {
                            precision: 0,
                            symbol: '',
                            decimal: ',',
                            thousand: ' ',
                          }
                        )}
                        <div className={"p-mt-3"}>
                          <Button type="button" label={props.t('editAction')} icon="pi pi-pencil"
                                  className="p-button-warning p-mr-2"
                                  onClick={() => {
                                    history.push('/project/' + entity + '/' + action + '/' + id + '?update=milestone&milestoneId=' + item?.original?.id)
                                  }}
                          />
                          <Button type="button" label="Teljesítés" icon="pi pi-check"
                                  className="p-button-success p-mr-2"
                                  onClick={() => {
                                    history.push('/project/' + entity + '/' + action + '/' + id + '?create=fulfilment&incomeActual=' + item.income_actual + '&name=' + item.label)
                                  }}
                          />
                        </div>
                      </>
                    )
                  }
                }}
      />
      {/*<div className={"p-grid p-p-0"}>*/}
      {/*  {milestones.map((milestone, index) => {*/}
      {/*    if(index !== milestones.length - 1) {*/}
      {/*      return(*/}
      {/*        <div className={"p-col p-px-0 p-mx-0"}>*/}
      {/*          <h4 className={"p-mt-0"}>*/}
      {/*            {milestone.label}*/}
      {/*          </h4>*/}
      {/*        </div>*/}
      {/*      )*/}
      {/*    }*/}
      {/*  })}*/}
      {/*</div>*/}
    </>
  )
}
export default withTranslation('common')(MilestoneListComponent);
